export enum AlternativeHousenumberExtensions {
  OTHER = 'Anders',
  NONE = 'Geen',
}
